import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { SubscriptionCompletePage } from '../pages/subscription-complete/subscription-complete.page';
import { SubscriptionFlowService } from '../services/subscription-flow.service';

export const subscriptionCompleteUnloadGuard: CanDeactivateFn<SubscriptionCompletePage> = (
  component,
  currentRoute,
  currentState,
  nextState
) => {
  const flow = inject(SubscriptionFlowService);
  const isPending: boolean = flow.isFlowActive() && flow.isPendingVerification();
  if (!isPending) return true;

  const confirmed: boolean = confirm(
    'Your subscription is being verified. Leaving now may cause issues with your payment. Are you sure you want to leave?'
  );

  if (confirmed) {
    flow.clearFlow();
  }

  return confirmed;
};
